module.exports = __webpack_public_path__ + "images/marketing/notepad-coffee-photo.jpg";